import { throttle } from '../../assets/js/utils/throttle.js'

export function initHeader($) {

  /* ========================================================================= *\
  **  === NAVBAR                                                               *| 
  \* ========================================================================= */
  
  let lastScrollTop = 0;
  $(window).scroll(throttle(function (e) {
    let st = $(this).scrollTop();
    let pageHeight = window.innerHeight;

    // if (st > lastScrollTop && st > pageHeight/10){
    //   // $('.header--nav').removeClass('is-active')
    //   $('.header--nav').css({'top': '0' })
    // } else {
    //   let heightHeaderFixed = $('.header--nav').outerHeight(true)
    //   $('.header--nav').css({'top': '-' + heightHeaderFixed + 'px' })
    // }

    if(!$('.hamburger').hasClass('is-active')) {
      if(st > pageHeight/20){
        $('.header--nav').addClass('is-down')
        $('.header--logo').addClass('white');
        $('.header--btn-menu .hamburger').addClass('white');
      } else {
        $('.header--nav').removeClass('is-down')
        $('.header--logo').removeClass('white');
        $('.header--btn-menu .hamburger').removeClass('white');
      }
    }
    lastScrollTop = st;
  }, 100));

  $('.hamburger').on('click', function(){
    $(this).toggleClass('is-active');
    $('.header--full').toggleClass('active');
    if($(this).hasClass('is-active')) {
      $('.header--nav').removeClass('is-down')
      $('.header--logo').addClass('white');
      $('.header--sticky').addClass('is-off');
      $('.header--btn-menu .hamburger').addClass('white');
    } else {
      $('.header--nav').addClass('is-down')
      $('.header--logo').removeClass('white');
      $('.header--sticky').removeClass('is-off');
      $('.header--sticky').removeClass('white');
      $('.header--btn-menu .hamburger').removeClass('white');
    }
    $('.formulaire--header-heading, .formulaire').removeClass('is-active'); // enlève la class is-active au header du form et a tous les forms
  });
}

export function initHeaderMenuScroll($) {
  var heightHeaderTop = $('.header--heading').height();

  // gsap.utils.toArray("section.colored--primary, section.colored--primary.marged, section.colored--img, .white_space.colored--primary, .white_space.colored--img").forEach(function (elem) {
  //   ScrollTrigger.create({
  //     trigger: elem,
  //     start: "top " + heightHeaderTop,
  //     end: "bottom " + heightHeaderTop,
  //     // markers: true,
  //     onLeave: () => { 
  //       $('.header--logo').removeClass('white');
  //       $('.header--sticky').removeClass('white');
  //       $('.header--btn-menu .hamburger').removeClass('white');
  //     },
  //     onEnter: () => { 
  //       $('.header--logo').addClass('white');
  //       $('.header--sticky').addClass('white');
  //       $('.header--btn-menu .hamburger').addClass('white');
  //     },
  //     onLeaveBack: () => { 
  //       $('.header--logo').removeClass('white');
  //       $('.header--sticky').removeClass('white');
  //       $('.header--btn-menu .hamburger').removeClass('white');
  //     },
  //     onEnterBack: () => { 
  //       $('.header--logo').addClass('white');
  //       $('.header--sticky').addClass('white');
  //       $('.header--btn-menu .hamburger').addClass('white');
  //     },
  //   })
  // });

  $(window).scroll(throttle(function (e) {
    if($('.header--full').hasClass('active'))
    {
      $('.header--logo').addClass('white');
      $('.header--sticky').addClass('white');
      $('.header--btn-menu .hamburger').addClass('white');
    }  
  }, 100));
}
